import axios from "axios";
import { successHandling } from "../helpers/successHandling";
import TextNoty from "../helpers/textNoty";

export const uploadFileToNubisDriveAPI = async (
  dataFromS3,
  file,
  md5Value,
  parentId,
  t,
  successfulText,
  onClose,
  setRefreshCapacity,
  reloadTable,
  setReturnValue,
  setDisabled,
  target,
  extra = {},
  onSuccess
) => {
  try {
    const formData = new FormData();
    formData.append("name", file.name);
    formData.append("extension", file.name.split(".").pop());
    formData.append("mime_type", file.type);
    formData.append("size", file.size);
    formData.append("s3_path", dataFromS3.Key);
    formData.append("md5", md5Value);
    formData.append("parent_id", parentId);
    if (target) {
      formData.append("target", target);
    }
    if (Object.keys(extra).length > 0) {
      for (var key in extra) {
        formData.append(key, extra[key]);
      }
    }
    const res = await axios({
      url: `/api/v2/drive/file/create`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    });
    if (!setReturnValue) {
      successHandling(t, successfulText);
    }
    if (setRefreshCapacity) setRefreshCapacity(true);
    if (setDisabled) {
      setDisabled(false);
    }
    if (reloadTable) reloadTable();
    if (onSuccess) {
      onSuccess({
        id: res?.data?.id,
        name: file.name,
        version: extra.version,
        upload_at: new Date().toISOString(),
        update_at: new Date().toISOString(),
        size: file.size,
        file_path: dataFromS3.Key,
        md5: md5Value,
        package_id: extra.package_id,  // windows为进程名称
        package_name: extra.package_name, // 程序名称
        version_code: extra.version_code,
        extend: extra.extend
      })
    }
    onClose(); // close the upload dialog
    return true;
  } catch (error) {
    if (setDisabled) {
      setDisabled(false);
    }
    if (error.response?.data?.errors?.size?.[0] === "storage_space_exceeded") {
      TextNoty(t("dialog.storageSpaceExceeded"));
      return;
    }
  }
};
